import VueRouter from 'vue-router';
import { FEATURE_UPDATED, IFeaturesFromQuery } from '@gig/magic-messages';

export function initCMSFeaturesQuery(router: VueRouter) {
    router.beforeEach((to, _, next) => {
        const query = to.query;
        const updatedFeatures: IFeaturesFromQuery = {};
        Object.entries(query).forEach(([key, value]) => {
            if (typeof value === 'string') {
                value = value.toLowerCase();
                if (value === 'true' || value === 'false') {
                    Object.assign(updatedFeatures, {
                        [key]: { active: JSON.parse(value), slug: key },
                    });
                } else {
                    Object.assign(updatedFeatures, {
                        [key]: { active: true, feature: value, slug: key },
                    });
                }
            }
        });
        window.eventBus.publish(FEATURE_UPDATED, updatedFeatures);
        return next();
    });
}
